import { csrfCookieName } from '@/lib/env'

export const csrfHeader = 'X-CSRF-Token'

export const readCookie = (name: string): string | null => {
  if (typeof document === 'undefined') {
    return null
  }

  const prefix = `${name}=`

  for (const entry of document.cookie.split(';')) {
    const candidate = entry.trim()

    if (candidate.startsWith(prefix)) {
      return decodeURIComponent(candidate.slice(prefix.length))
    }
  }

  return null
}

export const readCsrfToken = (): string | null => {
  const value = readCookie(csrfCookieName)

  return value === null || value === '' ? null : value
}
